import React from 'react';
import {Pressable, StyleSheet, View} from 'react-native';

import theme from '../../style/theme';

import Modal from './Modal';
import Text from './Text';

function Dialog({
  cancelText = 'CANCEL',
  cancelVisible = true,
  children = null,
  isVisible,
  okDisabled = false,
  okText = 'OK',
  okVisible = true,
  onCancel,
  onOk,
  title,
}: {
  cancelText?: string;
  cancelVisible?: boolean;
  children?: React.ReactNode;
  isVisible: boolean;
  okDisabled?: boolean;
  okText?: string;
  okVisible?: boolean;
  onCancel?: () => void;
  onOk: () => void;
  title: string;
}) {
  return (
    <Modal onBackdropPress={onCancel} isVisible={isVisible} title={title}>
      <>
        {children}
        <View style={styles.buttonsContainer}>
          {!!okVisible && (
            <Pressable
              onPress={onOk}
              style={{
                ...styles.okButton,
                ...styles.button,
              }}
              disabled={okDisabled}>
              <Text style={styles.disabledButton.text}>{okText}</Text>
            </Pressable>
          )}
          {!!cancelVisible && (
            <Pressable onPress={onCancel} style={styles.button}>
              <Text style={styles.button.text}>{cancelText}</Text>
            </Pressable>
          )}
        </View>
      </>
    </Modal>
  );
}

export default Dialog;

const styles = StyleSheet.create({
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  okButton: {
    marginTop: 8,
    marginBottom: 8,
  },
  disabledButton: {
    borderColor: 'darkgray',
    backgroundColor: 'lightgrey',
    paddingVertical: 8,
    borderRadius: 4,
    paddingHorizontal: 16,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600',
    },
  },
  button: {
    backgroundColor: theme.colour.background.button.primary,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600',
    },
  },
  checkboxContainer: {
    flexDirection: 'row',
  },
  checkbox: {
    alignSelf: 'center',
  },
  label: {
    margin: 8,
  },
});
